import { Component, Input } from '@angular/core';

import { EventOption, EventOptionGroup } from '@frontend/sports/betting-offer/feature/model';
import { groupBy, keys } from 'lodash-es';

export interface OptionGroup2 {
    attribute: string;
    options: (EventOption | undefined)[];
}

export interface GoalScorerHeader {
    name: string;
    optionGroupId: number;
}

@Component({ template: '' })
export class GoalScorerBaseComponent {
    @Input() optionGroup: EventOptionGroup;

    getOptions(optionGroup: EventOption[], columnIds: (number | undefined)[]): (EventOption | undefined)[] {
        const options: (EventOption | undefined)[] = [];
        for (const columnId of columnIds) {
            const groups = optionGroup.filter((o) => o.optionColumnId === columnId);
            if (!groups || groups.length === 0) {
                options.push(undefined);
            } else {
                options.push(groups[0]);
            }
        }

        return options;
    }

    getOptionHeaders(optionGroup: EventOption[]): GoalScorerHeader[] {
        const groups = groupBy(optionGroup, (option) => option.optionColumnSortOrder);

        return keys(groups).map(
            (key) => <GoalScorerHeader>{ name: groups[key][0].optionColumnName || '', optionGroupId: groups[key][0].optionGroupId },
        );
    }

    getOptionColumnIds(optionGroup: EventOption[]): (number | undefined)[] {
        const groups = groupBy(optionGroup, (option) => option.optionColumnSortOrder !== undefined && option.optionColumnSortOrder);
        return keys(groups).map((key) => groups[key][0].optionColumnId);
    }

    trackOption(index: number, option: EventOption | null): string {
        return option ? `${option.id}` : `_${index}`;
    }

    trackGroup(index: number, group: OptionGroup2): string {
        return group.attribute || '';
    }
}
